import { render, staticRenderFns } from "./job_full.vue?vue&type=template&id=3a50a63a&scoped=true"
import script from "./job_full.vue?vue&type=script&lang=js"
export * from "./job_full.vue?vue&type=script&lang=js"
import style0 from "./job_full.vue?vue&type=style&index=0&id=3a50a63a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a50a63a",
  null
  
)

export default component.exports